export enum PresentersRouteName {
    Presenters = 'presenters',
    Detail = 'presenters-detail',
    Create = 'presenters-create',
    Edit = 'presenters-edit'
}
